<template>
  <MainLayout>
    <div id="contents">
      <Payment />
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import Payment from '@/components/Payment.vue';

export default {
  name: 'PaymentView',
  components: {
    MainLayout,
    Payment,
  },
};
</script>
